import {
    Box,
    CircularProgress,
    circularProgressClasses
} from '@mui/material'

const CircularProgressBar = ({
  size = 30,
  value = 0,
  color = '',
  ...props
}) => {
  return (
    <Box
      sx={{ position: 'relative', display: 'flex', flexDirection: 'column' }}
    >
      <CircularProgress
        variant="determinate"
        value={100}
        size={size}
        sx={(theme) => ({
          color: theme.palette.grey[300],
          ...theme.applyStyles('dark', {
            color: theme.palette.grey[500]
          })
        })}
        {...props}
      />
      <CircularProgress
        variant="determinate"
        value={value}
        size={size}
        sx={(theme) => ({
          color,
          animationDuration: '550ms',
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round'
          },
          ...theme.applyStyles('dark', {
            color
          })
        })}
        {...props}
      />
    </Box>
  )
}

export default CircularProgressBar
